import { keysFromObject } from "../../utils/keysFromObject.mjs";
import { LOCALE_CODES } from "./index.mjs";
export const useI18nDateTimeFormats = () => {
  const dateTimeFormats = {
    "Y.numeric M.long D.numeric": {
      year: "numeric",
      month: "long",
      day: "numeric"
    },
    "Y.numeric M.2digit D.numeric": {
      year: "numeric",
      month: "2-digit",
      day: "numeric"
    },
    "Y.numeric M.short D.numeric": {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    "Y.numeric M.long": {
      year: "numeric",
      month: "long"
    },
    "Y.2-digit M.short D.numeric": {
      year: "2-digit",
      month: "short",
      day: "numeric"
    },
    "h.numeric m.numeric": {
      hour: "numeric",
      minute: "numeric"
    },
    "M.short D.numeric": {
      month: "short",
      day: "numeric"
    },
    "h.numeric": {
      hour: "numeric"
    },
    "full": {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    }
  };
  const { EN, EN_IE, EN_US } = LOCALE_CODES;
  const hour12LocaleCodes = [EN, EN_IE, EN_US];
  return keysFromObject(LOCALE_CODES).reduce(
    (acc, localeKey) => {
      const localeValue = LOCALE_CODES[localeKey];
      acc[localeValue] = keysFromObject(dateTimeFormats).reduce(
        (a, dateTimeFormatKey) => {
          a[dateTimeFormatKey] = { ...dateTimeFormats[dateTimeFormatKey] };
          if (a[dateTimeFormatKey].hour) {
            a[dateTimeFormatKey].hour12 = hour12LocaleCodes.includes(localeValue);
          }
          return a;
        },
        {}
      );
      return acc;
    },
    {}
  );
};
